// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2025-05-22T09:54:30Z                      #

// ##############################################################

// @ts-ignore - not used import
import {AxiosInstance, AxiosResponse, AxiosRequestConfig, CancelToken} from 'axios';
// @ts-ignore - not used import
import {unwrapResponse, generateUrl, baseAxios} from '@mc/axios-api';
// @ts-ignore - not used import
import * as importUrl from 'url';
// @ts-ignore - not used import
import MenuCountsVO from "./types/MenuCountsVO";
// @ts-ignore - not used import
import PreRequestVO from "./types/PreRequestVO";
// @ts-ignore - not used import
import SignRequestDocumentVO from "./types/SignRequestDocumentVO";
// @ts-ignore - not used import
import SignRequestWithCountsVO from "./types/SignRequestWithCountsVO";

// @ts-ignore - not used import
import * as UpdateMethods from "./UpdateMethods";


// @ts-ignore - not used import
type SimpleHeaders = {[key: string]: string};

/**
 *  Generated from cz.marbes.qsign.controller.QSignDataController.
 */
export default class QSignDataApi {
    /**
     * Počet aktivních položek, které mají být zobrazené v menu.
     *
     * @return napočítané položky pro menu
     */
    static getMenuCounts(config?: {cancelToken?: CancelToken}) : Promise<MenuCountsVO> {
        return unwrapResponse<MenuCountsVO>(QSignDataApi.raw.getMenuCounts(config));
    }
    /**
     * Seznam nevyřízených požadavků k podpisu pro podepisujícího; seřazené sestupně od nejnovějšího.
     *
     * @return seznam identifikátorů požadavků
     */
    static findNevyrizenePozadavkyPodepisujici(config?: {cancelToken?: CancelToken}) : Promise<number[]> {
        return unwrapResponse<number[]>(QSignDataApi.raw.findNevyrizenePozadavkyPodepisujici(config));
    }
    /**
     * Získání předběžných požadavků.
     *
     * @param ids identifikátory požadavků
     * @return nalezené požadavky s počty dokumentů
     */
    static findPreRequestsByIds(ids : number[], config?: {cancelToken?: CancelToken}) : Promise<PreRequestVO[]> {
        return unwrapResponse<PreRequestVO[]>(QSignDataApi.raw.findPreRequestsByIds(ids, config));
    }
    /**
     * Seznam jednotlivých odmítnutých dokumentů z požadavků zadávajícího uživatele; seřazené sestupně od naposledy změněného.
     *
     * @return seznam identifikátorů dokumentů
     */
    static findOdmitnuteDokumenty(config?: {cancelToken?: CancelToken}) : Promise<number[]> {
        return unwrapResponse<number[]>(QSignDataApi.raw.findOdmitnuteDokumenty(config));
    }
    /**
     * Získání požadavků s počty dokumentů.
     *
     * @param ids identifikátory požadavků
     * @return nalezené požadavky s počty dokumentů
     */
    static findRequestsByIds(ids : number[], config?: {cancelToken?: CancelToken}) : Promise<SignRequestWithCountsVO[]> {
        return unwrapResponse<SignRequestWithCountsVO[]>(QSignDataApi.raw.findRequestsByIds(ids, config));
    }
    /**
     * Seznam vyřízených požadavků schvalujícího; seřazené sestupně od nejnovějšího.
     *
     * @return seznam identifikátorů požadavků
     */
    static findHistorickeDokumentySchvalujici(config?: {cancelToken?: CancelToken}) : Promise<number[]> {
        return unwrapResponse<number[]>(QSignDataApi.raw.findHistorickeDokumentySchvalujici(config));
    }
    /**
     * Seznam nevyřízených předběžných požadavků zadávajícího uživatele; seřazené sestupně od nejnovějšího.
     *
     * @return seznam identifikátorů předběžných požadavků
     */
    static findNevyrizenePrePozadavkyPredkladatel(config?: {cancelToken?: CancelToken}) : Promise<number[]> {
        return unwrapResponse<number[]>(QSignDataApi.raw.findNevyrizenePrePozadavkyPredkladatel(config));
    }
    /**
     * Seznam jednotlivých dokumentů (podepsané a odmítnuté s příznakem vyřízení) z požadavků zadávajícího uživatele; seřazené sestupně od naposledy změněného.
     *
     * @return seznam identifikátorů dokumentů
     */
    static findHistorickeDokumenty(config?: {cancelToken?: CancelToken}) : Promise<number[]> {
        return unwrapResponse<number[]>(QSignDataApi.raw.findHistorickeDokumenty(config));
    }
    /**
     * Seznam nevyřízených požadavků zadávajícího uživatele; seřazené sestupně od nejnovějšího.
     *
     * @return seznam identifikátorů požadavků
     */
    static findNevyrizenePozadavkyPredkladatel(config?: {cancelToken?: CancelToken}) : Promise<number[]> {
        return unwrapResponse<number[]>(QSignDataApi.raw.findNevyrizenePozadavkyPredkladatel(config));
    }
    /**
     * Seznam vyřízených požadavků zadávajícího uživatele; seřazené sestupně od nejnovějšího.
     *
     * @return seznam identifikátorů požadavků
     */
    static findVyrizenePozadavky(config?: {cancelToken?: CancelToken}) : Promise<number[]> {
        return unwrapResponse<number[]>(QSignDataApi.raw.findVyrizenePozadavky(config));
    }
    /**
     * Vygenerování a stažení košilky dokumentu.
     *
     * @param pdfView identifikátor session prohlížečky
     * @param documentView identifikátor dokumentu prohlížečky
     */
    static downloadSummary(pdfView : string, documentView : string, config?: {cancelToken?: CancelToken}) {
        return unwrapResponse<any>(QSignDataApi.raw.downloadSummary(pdfView, documentView, config));
    }
    /**
     * Seznam jednotlivých dokumentů (podepsané a odmítnuté) z požadavků podepisujícího uživatele; seřazené sestupně od naposledy změněného.
     *
     * @return seznam identifikátorů dokumentů
     */
    static findHistorickeDokumentyPodepisujici(config?: {cancelToken?: CancelToken}) : Promise<number[]> {
        return unwrapResponse<number[]>(QSignDataApi.raw.findHistorickeDokumentyPodepisujici(config));
    }
    /**
     * Získání dokumentů.
     *
     * @param ids identifikátory dokumentů
     * @return nalezené dokumenty
     */
    static findRequestDocumentsByIds(ids : number[], config?: {cancelToken?: CancelToken}) : Promise<SignRequestDocumentVO[]> {
        return unwrapResponse<SignRequestDocumentVO[]>(QSignDataApi.raw.findRequestDocumentsByIds(ids, config));
    }
    /**
     * Seznam nevyřízených požadavků ke schválení pro schvalujícího; seřazené sestupně od nejnovějšího.
     *
     * @return seznam identifikátorů požadavků
     */
    static findNevyrizenePozadavkySchvalujici(config?: {cancelToken?: CancelToken}) : Promise<number[]> {
        return unwrapResponse<number[]>(QSignDataApi.raw.findNevyrizenePozadavkySchvalujici(config));
    }
    /**
     * Seznam nevyřízených požadavků zadávajícího uživatele; seřazené sestupně od nejnovějšího.
     *
     * @param podepisujiciId 
     * @param schvalovatelId 
     * @return seznam identifikátorů požadavků
     */
    static findNevyrizenePozadavkyPredkladatelAndPodepisujiciSchvalovatel(podepisujiciId : number, schvalovatelId : number, config?: {cancelToken?: CancelToken}) : Promise<number[]> {
        return unwrapResponse<number[]>(QSignDataApi.raw.findNevyrizenePozadavkyPredkladatelAndPodepisujiciSchvalovatel(podepisujiciId, schvalovatelId, config));
    }

    static raw = {
            getMenuCounts: function(config?: AxiosRequestConfig, axiosInstance: AxiosInstance = baseAxios): Promise<AxiosResponse<MenuCountsVO>> {
                const uri = `/qsign/api/menu/count`;
                const headers : SimpleHeaders = {};
                headers['Content-Type'] = 'application/json';

                const params = {  };
                 

                const finalUri = params && Object.keys(params).length > 0 ? uri + importUrl.format({query: params}) : uri;

                let finalHeaders;
                if (config && config.headers) {
                    finalHeaders = {
                        ...(headers || {}),
                        ...config.headers
                    };
                } else {
                    finalHeaders = headers;
                }

                const finalConfig = {
                    ...config,
                    headers: finalHeaders
                }


                return axiosInstance.get<any, AxiosResponse<MenuCountsVO>>(finalUri, finalConfig);
            },
            findNevyrizenePozadavkyPodepisujici: function(config?: AxiosRequestConfig, axiosInstance: AxiosInstance = baseAxios): Promise<AxiosResponse<number[]>> {
                const uri = `/qsign/api/signRequest/nevyrizenePozadavkyPodepisujici`;
                const headers : SimpleHeaders = {};
                headers['Content-Type'] = 'application/json';

                const params = {  };
                 

                const finalUri = params && Object.keys(params).length > 0 ? uri + importUrl.format({query: params}) : uri;

                let finalHeaders;
                if (config && config.headers) {
                    finalHeaders = {
                        ...(headers || {}),
                        ...config.headers
                    };
                } else {
                    finalHeaders = headers;
                }

                const finalConfig = {
                    ...config,
                    headers: finalHeaders
                }


                return axiosInstance.post<any, AxiosResponse<number[]>>(finalUri, 0, finalConfig);
            },
            findPreRequestsByIds: function(ids : number[], config?: AxiosRequestConfig, axiosInstance: AxiosInstance = baseAxios): Promise<AxiosResponse<PreRequestVO[]>> {
                const uri = `/qsign/api/preSignRequest/byIds`;
                const headers : SimpleHeaders = {};
                headers['Content-Type'] = 'application/json';

                const params = {  };
                 

                const finalUri = params && Object.keys(params).length > 0 ? uri + importUrl.format({query: params}) : uri;

                let finalHeaders;
                if (config && config.headers) {
                    finalHeaders = {
                        ...(headers || {}),
                        ...config.headers
                    };
                } else {
                    finalHeaders = headers;
                }

                const finalConfig = {
                    ...config,
                    headers: finalHeaders
                }


                return axiosInstance.post<any, AxiosResponse<PreRequestVO[]>>(finalUri, ids, finalConfig);
            },
            findOdmitnuteDokumenty: function(config?: AxiosRequestConfig, axiosInstance: AxiosInstance = baseAxios): Promise<AxiosResponse<number[]>> {
                const uri = `/qsign/api/signRequestDocument/odmitnute`;
                const headers : SimpleHeaders = {};
                headers['Content-Type'] = 'application/json';

                const params = {  };
                 

                const finalUri = params && Object.keys(params).length > 0 ? uri + importUrl.format({query: params}) : uri;

                let finalHeaders;
                if (config && config.headers) {
                    finalHeaders = {
                        ...(headers || {}),
                        ...config.headers
                    };
                } else {
                    finalHeaders = headers;
                }

                const finalConfig = {
                    ...config,
                    headers: finalHeaders
                }


                return axiosInstance.post<any, AxiosResponse<number[]>>(finalUri, 0, finalConfig);
            },
            findRequestsByIds: function(ids : number[], config?: AxiosRequestConfig, axiosInstance: AxiosInstance = baseAxios): Promise<AxiosResponse<SignRequestWithCountsVO[]>> {
                const uri = `/qsign/api/signRequest/byIds`;
                const headers : SimpleHeaders = {};
                headers['Content-Type'] = 'application/json';

                const params = {  };
                 

                const finalUri = params && Object.keys(params).length > 0 ? uri + importUrl.format({query: params}) : uri;

                let finalHeaders;
                if (config && config.headers) {
                    finalHeaders = {
                        ...(headers || {}),
                        ...config.headers
                    };
                } else {
                    finalHeaders = headers;
                }

                const finalConfig = {
                    ...config,
                    headers: finalHeaders
                }


                return axiosInstance.post<any, AxiosResponse<SignRequestWithCountsVO[]>>(finalUri, ids, finalConfig);
            },
            findHistorickeDokumentySchvalujici: function(config?: AxiosRequestConfig, axiosInstance: AxiosInstance = baseAxios): Promise<AxiosResponse<number[]>> {
                const uri = `/qsign/api/signRequest/historickeDokumentySchvalujici`;
                const headers : SimpleHeaders = {};
                headers['Content-Type'] = 'application/json';

                const params = {  };
                 

                const finalUri = params && Object.keys(params).length > 0 ? uri + importUrl.format({query: params}) : uri;

                let finalHeaders;
                if (config && config.headers) {
                    finalHeaders = {
                        ...(headers || {}),
                        ...config.headers
                    };
                } else {
                    finalHeaders = headers;
                }

                const finalConfig = {
                    ...config,
                    headers: finalHeaders
                }


                return axiosInstance.post<any, AxiosResponse<number[]>>(finalUri, 0, finalConfig);
            },
            findNevyrizenePrePozadavkyPredkladatel: function(config?: AxiosRequestConfig, axiosInstance: AxiosInstance = baseAxios): Promise<AxiosResponse<number[]>> {
                const uri = `/qsign/api/preSignRequest/nevyrizenePrePozadavkyPredkladatel`;
                const headers : SimpleHeaders = {};
                headers['Content-Type'] = 'application/json';

                const params = {  };
                 

                const finalUri = params && Object.keys(params).length > 0 ? uri + importUrl.format({query: params}) : uri;

                let finalHeaders;
                if (config && config.headers) {
                    finalHeaders = {
                        ...(headers || {}),
                        ...config.headers
                    };
                } else {
                    finalHeaders = headers;
                }

                const finalConfig = {
                    ...config,
                    headers: finalHeaders
                }


                return axiosInstance.post<any, AxiosResponse<number[]>>(finalUri, 0, finalConfig);
            },
            findHistorickeDokumenty: function(config?: AxiosRequestConfig, axiosInstance: AxiosInstance = baseAxios): Promise<AxiosResponse<number[]>> {
                const uri = `/qsign/api/signRequestDocument/historie`;
                const headers : SimpleHeaders = {};
                headers['Content-Type'] = 'application/json';

                const params = {  };
                 

                const finalUri = params && Object.keys(params).length > 0 ? uri + importUrl.format({query: params}) : uri;

                let finalHeaders;
                if (config && config.headers) {
                    finalHeaders = {
                        ...(headers || {}),
                        ...config.headers
                    };
                } else {
                    finalHeaders = headers;
                }

                const finalConfig = {
                    ...config,
                    headers: finalHeaders
                }


                return axiosInstance.post<any, AxiosResponse<number[]>>(finalUri, 0, finalConfig);
            },
            findNevyrizenePozadavkyPredkladatel: function(config?: AxiosRequestConfig, axiosInstance: AxiosInstance = baseAxios): Promise<AxiosResponse<number[]>> {
                const uri = `/qsign/api/signRequest/nevyrizenePozadavkyPredkladatel`;
                const headers : SimpleHeaders = {};
                headers['Content-Type'] = 'application/json';

                const params = {  };
                 

                const finalUri = params && Object.keys(params).length > 0 ? uri + importUrl.format({query: params}) : uri;

                let finalHeaders;
                if (config && config.headers) {
                    finalHeaders = {
                        ...(headers || {}),
                        ...config.headers
                    };
                } else {
                    finalHeaders = headers;
                }

                const finalConfig = {
                    ...config,
                    headers: finalHeaders
                }


                return axiosInstance.post<any, AxiosResponse<number[]>>(finalUri, 0, finalConfig);
            },
            findVyrizenePozadavky: function(config?: AxiosRequestConfig, axiosInstance: AxiosInstance = baseAxios): Promise<AxiosResponse<number[]>> {
                const uri = `/qsign/api/signRequest/vyrizenePozadavky`;
                const headers : SimpleHeaders = {};
                headers['Content-Type'] = 'application/json';

                const params = {  };
                 

                const finalUri = params && Object.keys(params).length > 0 ? uri + importUrl.format({query: params}) : uri;

                let finalHeaders;
                if (config && config.headers) {
                    finalHeaders = {
                        ...(headers || {}),
                        ...config.headers
                    };
                } else {
                    finalHeaders = headers;
                }

                const finalConfig = {
                    ...config,
                    headers: finalHeaders
                }


                return axiosInstance.post<any, AxiosResponse<number[]>>(finalUri, 0, finalConfig);
            },
            downloadSummary: function(pdfView : string, documentView : string, config?: AxiosRequestConfig, axiosInstance: AxiosInstance = baseAxios): Promise<AxiosResponse<any>> {
                const uri = `/qsign/api/downloadSummary/${pdfView}/${documentView}`;
                const headers : SimpleHeaders = {};
                headers['Content-Type'] = 'application/json';

                const params = {  };
                 

                const finalUri = params && Object.keys(params).length > 0 ? uri + importUrl.format({query: params}) : uri;

                let finalHeaders;
                if (config && config.headers) {
                    finalHeaders = {
                        ...(headers || {}),
                        ...config.headers
                    };
                } else {
                    finalHeaders = headers;
                }

                const finalConfig = {
                    ...config,
                    headers: finalHeaders
                }


                return axiosInstance.get<any, any>(finalUri, finalConfig);
            },
            findHistorickeDokumentyPodepisujici: function(config?: AxiosRequestConfig, axiosInstance: AxiosInstance = baseAxios): Promise<AxiosResponse<number[]>> {
                const uri = `/qsign/api/signRequestDocument/historiePodepisujici`;
                const headers : SimpleHeaders = {};
                headers['Content-Type'] = 'application/json';

                const params = {  };
                 

                const finalUri = params && Object.keys(params).length > 0 ? uri + importUrl.format({query: params}) : uri;

                let finalHeaders;
                if (config && config.headers) {
                    finalHeaders = {
                        ...(headers || {}),
                        ...config.headers
                    };
                } else {
                    finalHeaders = headers;
                }

                const finalConfig = {
                    ...config,
                    headers: finalHeaders
                }


                return axiosInstance.post<any, AxiosResponse<number[]>>(finalUri, 0, finalConfig);
            },
            findRequestDocumentsByIds: function(ids : number[], config?: AxiosRequestConfig, axiosInstance: AxiosInstance = baseAxios): Promise<AxiosResponse<SignRequestDocumentVO[]>> {
                const uri = `/qsign/api/signRequestDocument/byIds`;
                const headers : SimpleHeaders = {};
                headers['Content-Type'] = 'application/json';

                const params = {  };
                 

                const finalUri = params && Object.keys(params).length > 0 ? uri + importUrl.format({query: params}) : uri;

                let finalHeaders;
                if (config && config.headers) {
                    finalHeaders = {
                        ...(headers || {}),
                        ...config.headers
                    };
                } else {
                    finalHeaders = headers;
                }

                const finalConfig = {
                    ...config,
                    headers: finalHeaders
                }


                return axiosInstance.post<any, AxiosResponse<SignRequestDocumentVO[]>>(finalUri, ids, finalConfig);
            },
            findNevyrizenePozadavkySchvalujici: function(config?: AxiosRequestConfig, axiosInstance: AxiosInstance = baseAxios): Promise<AxiosResponse<number[]>> {
                const uri = `/qsign/api/signRequest/nevyrizenePozadavkySchvalujici`;
                const headers : SimpleHeaders = {};
                headers['Content-Type'] = 'application/json';

                const params = {  };
                 

                const finalUri = params && Object.keys(params).length > 0 ? uri + importUrl.format({query: params}) : uri;

                let finalHeaders;
                if (config && config.headers) {
                    finalHeaders = {
                        ...(headers || {}),
                        ...config.headers
                    };
                } else {
                    finalHeaders = headers;
                }

                const finalConfig = {
                    ...config,
                    headers: finalHeaders
                }


                return axiosInstance.post<any, AxiosResponse<number[]>>(finalUri, 0, finalConfig);
            },
            findNevyrizenePozadavkyPredkladatelAndPodepisujiciSchvalovatel: function(podepisujiciId : number, schvalovatelId : number, config?: AxiosRequestConfig, axiosInstance: AxiosInstance = baseAxios): Promise<AxiosResponse<number[]>> {
                const uri = `/qsign/api/signRequest/nevyrizenePozadavkyPredkladatel/podepisujiciSchvalovatel`;
                const headers : SimpleHeaders = {};
                headers['Content-Type'] = 'application/json';

                const params = { podepisujiciId, schvalovatelId };
                 

                const finalUri = params && Object.keys(params).length > 0 ? uri + importUrl.format({query: params}) : uri;

                let finalHeaders;
                if (config && config.headers) {
                    finalHeaders = {
                        ...(headers || {}),
                        ...config.headers
                    };
                } else {
                    finalHeaders = headers;
                }

                const finalConfig = {
                    ...config,
                    headers: finalHeaders
                }


                return axiosInstance.post<any, AxiosResponse<number[]>>(finalUri, 0, finalConfig);
            },
    }
}
